var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorLoginIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 259.751,
    height: 186.824,
    viewBox: "0 0 259.751 186.824",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error_login",
    "data-name": "Error login",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_995",
    "data-name": "Rectangle 995",
    width: 126.294,
    height: 134.371,
    rx: 19.89,
    transform: "translate(26.36)",
    fill: "#dfdfdf",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M120.994,133.982l-5.9-.039a6.568,6.568,0,0,1-6.208-4.483,47.852,47.852,0,0,0-1.81-4.666,6.661,6.661,0,0,1,1.425-7.469l4.091-4.038a6.709,6.709,0,0,0,.065-9.488l-6.8-6.9a6.709,6.709,0,0,0-9.488-.065l-3.679,3.627a6.728,6.728,0,0,1-7.77,1.189,47.426,47.426,0,0,0-4.79-2.1,6.719,6.719,0,0,1-4.372-6.332l.033-5.077a6.713,6.713,0,0,0-6.665-6.757l-9.691-.065a6.713,6.713,0,0,0-6.757,6.665l-.033,4.77a6.708,6.708,0,0,1-4.587,6.312,47.42,47.42,0,0,0-5.1,2.052,6.719,6.719,0,0,1-7.652-1.346L31.974,96.4a6.709,6.709,0,0,0-9.488-.065l-6.9,6.8a6.709,6.709,0,0,0-.065,9.488l3.418,3.47a6.719,6.719,0,0,1,1.261,7.632,46.17,46.17,0,0,0-2.052,4.986,6.72,6.72,0,0,1-6.391,4.528L6.829,133.2A6.713,6.713,0,0,0,.072,139.87L0,149.548A6.713,6.713,0,0,0,6.665,156.3l5.411.039A6.665,6.665,0,0,1,18.31,160.7a46.991,46.991,0,0,0,2.019,4.757A6.675,6.675,0,0,1,19,173.131L15.075,177a6.709,6.709,0,0,0-.065,9.488l6.8,6.9a6.709,6.709,0,0,0,9.488.065l4.4-4.339a6.532,6.532,0,0,1,7.358-1.294c1.411.66,2.862,1.261,4.346,1.784a6.8,6.8,0,0,1,4.522,6.463l-.039,6.071a6.713,6.713,0,0,0,6.665,6.757l9.691.065A6.713,6.713,0,0,0,75,202.295l.046-6.378a6.808,6.808,0,0,1,4.5-6.365q2.049-.735,4.019-1.653a6.689,6.689,0,0,1,7.593,1.379l4.548,4.613a6.709,6.709,0,0,0,9.488.065l6.9-6.8a6.709,6.709,0,0,0,.065-9.488l-4.463-4.522a6.687,6.687,0,0,1-1.255-7.645c.673-1.372,1.281-2.784,1.823-4.221a6.566,6.566,0,0,1,6.2-4.234l6.384.046a6.713,6.713,0,0,0,6.757-6.665l.065-9.691A6.713,6.713,0,0,0,121,133.976ZM61.19,169.23a26.4,26.4,0,1,0,0-.007Z",
    transform: "translate(0 -28.181)",
    fill: "#f39797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M344.559,113.605l-4.2-.026a4.667,4.667,0,0,1-4.417-3.2,33.881,33.881,0,0,0-1.287-3.32,4.749,4.749,0,0,1,1.013-5.319l2.914-2.875a4.778,4.778,0,0,0,.046-6.757L333.784,87.2a4.778,4.778,0,0,0-6.757-.046l-2.62,2.581a4.784,4.784,0,0,1-5.528.85,34.551,34.551,0,0,0-3.411-1.5,4.783,4.783,0,0,1-3.11-4.509l.026-3.614a4.775,4.775,0,0,0-4.744-4.809l-6.9-.046a4.775,4.775,0,0,0-4.809,4.744l-.026,3.391a4.779,4.779,0,0,1-3.261,4.5,34.415,34.415,0,0,0-3.627,1.457,4.786,4.786,0,0,1-5.443-.961l-2.372-2.4a4.77,4.77,0,0,0-6.75-.046l-4.914,4.842a4.77,4.77,0,0,0-.046,6.75l2.431,2.47a4.777,4.777,0,0,1,.9,5.43,35.183,35.183,0,0,0-1.464,3.548,4.778,4.778,0,0,1-4.548,3.222l-3.509-.026a4.775,4.775,0,0,0-4.809,4.744l-.046,6.9a4.775,4.775,0,0,0,4.744,4.809l3.849.026a4.735,4.735,0,0,1,4.437,3.1,33.073,33.073,0,0,0,1.438,3.385,4.764,4.764,0,0,1-.947,5.469l-2.79,2.751a4.77,4.77,0,0,0-.046,6.75l4.842,4.914a4.778,4.778,0,0,0,6.757.046l3.13-3.084a4.665,4.665,0,0,1,5.241-.921q1.51.706,3.091,1.268a4.842,4.842,0,0,1,3.222,4.6l-.033,4.319a4.775,4.775,0,0,0,4.744,4.809l6.9.046a4.775,4.775,0,0,0,4.81-4.744l.033-4.542a4.838,4.838,0,0,1,3.2-4.528c.974-.346,1.928-.745,2.856-1.176a4.773,4.773,0,0,1,5.4.98l3.235,3.28a4.77,4.77,0,0,0,6.75.046l4.914-4.842a4.778,4.778,0,0,0,.046-6.757l-3.176-3.222a4.767,4.767,0,0,1-.9-5.443c.477-.974.908-1.98,1.294-3.006a4.674,4.674,0,0,1,4.417-3.012l4.548.033a4.775,4.775,0,0,0,4.809-4.744l.046-6.9a4.775,4.775,0,0,0-4.744-4.809Zm-42.566,25.086a18.792,18.792,0,1,0,0-.007Z",
    transform: "translate(-89.56 -26.375)",
    fill: "#d9dfed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M130.6,45.591l-1.509-.013a1.68,1.68,0,0,1-1.588-1.144,12.455,12.455,0,0,0-.464-1.189,1.692,1.692,0,0,1,.366-1.908l1.046-1.032a1.72,1.72,0,0,0,.02-2.424l-1.738-1.764a1.72,1.72,0,0,0-2.424-.02l-.941.928a1.718,1.718,0,0,1-1.986.307,11.934,11.934,0,0,0-1.222-.536,1.718,1.718,0,0,1-1.117-1.621v-1.3a1.7,1.7,0,0,0-1.692-1.725l-2.477-.02a1.715,1.715,0,0,0-1.725,1.706v1.222a1.735,1.735,0,0,1-1.183,1.614,13.286,13.286,0,0,0-1.307.523,1.7,1.7,0,0,1-1.954-.346l-.85-.863a1.72,1.72,0,0,0-2.424-.02L103.666,37.7a1.72,1.72,0,0,0-.02,2.424l.876.889a1.72,1.72,0,0,1,.32,1.954,12.112,12.112,0,0,0-.523,1.274,1.709,1.709,0,0,1-1.634,1.157h-1.261A1.7,1.7,0,0,0,99.7,47.094l-.02,2.477a1.715,1.715,0,0,0,1.706,1.725h1.385a1.717,1.717,0,0,1,1.594,1.124,11.117,11.117,0,0,0,.516,1.215,1.7,1.7,0,0,1-.34,1.96l-1,.987a1.72,1.72,0,0,0-.02,2.424l1.738,1.764a1.72,1.72,0,0,0,2.424.02l1.124-1.111a1.679,1.679,0,0,1,1.882-.333c.359.17.732.32,1.111.457a1.74,1.74,0,0,1,1.157,1.653l-.013,1.555a1.715,1.715,0,0,0,1.706,1.725l2.477.02a1.715,1.715,0,0,0,1.725-1.706l.013-1.634a1.734,1.734,0,0,1,1.15-1.627,10.913,10.913,0,0,0,1.026-.425,1.709,1.709,0,0,1,1.941.353l1.163,1.176a1.72,1.72,0,0,0,2.424.02l1.764-1.738a1.72,1.72,0,0,0,.02-2.424L127.21,55.6a1.711,1.711,0,0,1-.32-1.954c.17-.353.327-.712.464-1.078a1.686,1.686,0,0,1,1.588-1.085l1.634.013a1.715,1.715,0,0,0,1.725-1.706l.02-2.477a1.715,1.715,0,0,0-1.706-1.725ZM115.311,54.6a6.846,6.846,0,1,1,.007,0Z",
    transform: "translate(-34.543 -11.134)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M212.675,49.385l-2.764-.02a3.074,3.074,0,0,1-2.908-2.1,22.541,22.541,0,0,0-.849-2.183,3.114,3.114,0,0,1,.667-3.5l1.915-1.888a3.145,3.145,0,0,0,.033-4.444l-3.182-3.228A3.145,3.145,0,0,0,201.142,32l-1.725,1.7a3.144,3.144,0,0,1-3.64.555,22.8,22.8,0,0,0-2.241-.98A3.144,3.144,0,0,1,191.49,30.3l.02-2.379a3.143,3.143,0,0,0-3.117-3.163l-4.535-.033a3.143,3.143,0,0,0-3.163,3.117l-.013,2.228a3.135,3.135,0,0,1-2.143,2.954,21.638,21.638,0,0,0-2.385.961,3.141,3.141,0,0,1-3.581-.634l-1.562-1.581a3.145,3.145,0,0,0-4.444-.033l-3.228,3.182a3.145,3.145,0,0,0-.033,4.444l1.6,1.621a3.144,3.144,0,0,1,.588,3.574,21.341,21.341,0,0,0-.961,2.333,3.139,3.139,0,0,1-2.993,2.117L159.235,49a3.143,3.143,0,0,0-3.163,3.117l-.033,4.535a3.143,3.143,0,0,0,3.117,3.163l2.535.02a3.1,3.1,0,0,1,2.914,2.039,21.682,21.682,0,0,0,.941,2.228,3.128,3.128,0,0,1-.621,3.594l-1.836,1.81a3.145,3.145,0,0,0-.033,4.444l3.182,3.228a3.145,3.145,0,0,0,4.444.033l2.058-2.032a3.057,3.057,0,0,1,3.444-.608c.66.307,1.34.588,2.032.836a3.187,3.187,0,0,1,2.117,3.026l-.02,2.843a3.143,3.143,0,0,0,3.117,3.163l4.535.033a3.143,3.143,0,0,0,3.163-3.117l.02-2.986a3.189,3.189,0,0,1,2.1-2.98c.64-.229,1.268-.49,1.882-.771a3.126,3.126,0,0,1,3.555.647l2.13,2.156a3.145,3.145,0,0,0,4.444.033l3.228-3.182a3.145,3.145,0,0,0,.033-4.444l-2.091-2.117a3.135,3.135,0,0,1-.588-3.581,20.511,20.511,0,0,0,.85-1.98,3.08,3.08,0,0,1,2.9-1.98l2.986.02a3.143,3.143,0,0,0,3.163-3.117l.033-4.535a3.143,3.143,0,0,0-3.117-3.163ZM185.093,62.147a8.264,8.264,0,1,1,0,.007Z",
    transform: "translate(-54.074 -8.57)",
    fill: "#febc75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M292.175,235.738,269.7,170.045A38.442,38.442,0,0,0,226,144.58c-.294.059-.588.124-.882.19l-42.4,8.724c-14.324,3.208-23.694,8.279-29.314,28.386L138.2,235.738H292.181Z",
    transform: "translate(-47.892 -49.848)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M245.648,145.9l-40.358,8.305c-.66.15-1.307.3-1.941.457a22.489,22.489,0,0,0,42.3-8.763Z",
    transform: "translate(-70.469 -50.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M291.754,236.109H137.773a.789.789,0,0,1-.758-1l15.206-53.858c5.574-19.944,14.807-25.557,29.9-28.935l42.416-8.73c.288-.065.588-.131.889-.189a39.3,39.3,0,0,1,44.605,25.982L292.5,235.07a.772.772,0,0,1-.1.712A.781.781,0,0,1,291.754,236.109Zm-152.942-1.568H290.656l-22.12-64.653a37.711,37.711,0,0,0-42.808-24.949c-.287.059-.575.118-.869.183l-42.416,8.73c-14.814,3.32-23.322,8.534-28.713,27.824l-14.925,52.865Z",
    transform: "translate(-47.471 -49.435)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M186.148,104.686a6.147,6.147,0,1,0,3.313-8.038A6.141,6.141,0,0,0,186.148,104.686Z",
    transform: "translate(-64.343 -33.328)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 19.336,
    cy: 19.336,
    r: 19.336,
    transform: "matrix(0.786, -0.619, 0.619, 0.786, 123.673, 68.001)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M205.772,93.271c-8.763,1.967-12.651,4.875-8.077,25.276,2.352,10.482,5.666,11.377,15.958,9.331l1.686,7.534,17.277-3.875-7.7-34.333s-11.292-5.692-19.146-3.934Z",
    transform: "translate(-67.84 -32.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M214.606,134.349a.782.782,0,0,1-.765-.614l-1.2-5.358c-10.116,1.928-13.723.627-16.121-10.076-2.254-10.044-2.535-16.225-.915-20.029,1.745-4.11,5.7-5.313,9.593-6.182,8.031-1.8,19.2,3.764,19.669,4a.787.787,0,0,1,.412.529l7.3,32.562a.787.787,0,0,1-1.536.346L223.82,97.337c-1.9-.9-11.534-5.221-18.29-3.712-7.868,1.764-12.1,3.764-7.482,24.341,2.222,9.9,5.032,10.723,15.036,8.73a.788.788,0,0,1,.921.6l1.366,6.1a.786.786,0,0,1-.595.941.8.8,0,0,1-.17.02Z",
    transform: "translate(-67.428 -31.788)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M226.129,91.045s-2.385,16.787,7.123,14.585c0,0-1.287,12.481,7.031,10.619l-.49-16.729-7.345-15.16-6.319,6.678Z",
    transform: "translate(-78.271 -29.234)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M202.15,120.637a1.068,1.068,0,1,1-1.274-.81A1.065,1.065,0,0,1,202.15,120.637Z",
    transform: "translate(-69.322 -41.516)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M217.56,117.176a1.068,1.068,0,1,1-1.274-.81A1.065,1.065,0,0,1,217.56,117.176Z",
    transform: "translate(-74.662 -40.316)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M222.725,146.246a.782.782,0,0,1-.157-1.549l4.77-1.006a.784.784,0,0,1,.32,1.536l-4.77,1.006a.7.7,0,0,1-.163.02Z",
    transform: "translate(-76.912 -49.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M229.11,116.263s.4-5.509,3.764-7.031c2.973-1.346,7.7,1.509,7.619,5.724s-6.848,4.94-6.848,4.94Z",
    transform: "translate(-79.396 -37.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M235.224,119.267a.781.781,0,0,1-.784-.778,5.2,5.2,0,0,1,4.28-5.1.786.786,0,1,1,.3,1.542c-.137.026-3.039.66-3.012,3.542a.787.787,0,0,1-.778.791Z",
    transform: "translate(-81.243 -39.29)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M215.988,94.516a6.147,6.147,0,1,0,3.313-8.038A6.141,6.141,0,0,0,215.988,94.516Z",
    transform: "translate(-74.684 -29.804)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M200.7,94.516a6.147,6.147,0,1,0,3.313-8.038A6.141,6.141,0,0,0,200.7,94.516Z",
    transform: "translate(-69.386 -29.804)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M185.658,95.276a6.147,6.147,0,1,0,3.313-8.038A6.141,6.141,0,0,0,185.658,95.276Z",
    transform: "translate(-64.174 -30.067)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M206.708,78.966a6.147,6.147,0,1,0,3.313-8.038A6.141,6.141,0,0,0,206.708,78.966Z",
    transform: "translate(-71.468 -24.415)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M192.278,82.626a6.147,6.147,0,1,0,3.313-8.038A6.141,6.141,0,0,0,192.278,82.626Z",
    transform: "translate(-66.468 -25.683)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M221.9,80.246a6.147,6.147,0,1,0,3.313-8.038A6.141,6.141,0,0,0,221.9,80.246Z",
    transform: "translate(-76.732 -24.858)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M256.236,94.6a.759.759,0,0,1-.582-.261.767.767,0,0,1-.183-.673l.706-3.672a.786.786,0,0,1,1.542.3l-.51,2.666,1.96-.157a.783.783,0,1,1,.124,1.562l-2.986.235h-.059Z",
    transform: "translate(-88.525 -30.966)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M216.216,109.706a1.018,1.018,0,0,0-.405-1.523,5.2,5.2,0,0,0-3.346-.222,5.368,5.368,0,0,0-2.535,1.464,1.031,1.031,0,0,0-.118,1.32l.059.085a1.027,1.027,0,0,0,1.464.222,4.968,4.968,0,0,1,1.823-.928,6.739,6.739,0,0,1,2.085.007,1.03,1.03,0,0,0,.98-.425h0Z",
    transform: "translate(-72.644 -37.355)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M196.891,115.545l-.189.078a1.129,1.129,0,0,0-.582,1.483,1.147,1.147,0,0,0,1.562.569,2.253,2.253,0,0,1,.222-.091,6.743,6.743,0,0,1,2.058-.314,1.028,1.028,0,0,0,.274-2.013A5.2,5.2,0,0,0,196.891,115.545Z",
    transform: "translate(-67.931 -39.887)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M203.695,125.617a2.963,2.963,0,0,1-1.411-5.646l-.549-2.431a.787.787,0,1,1,1.536-.346l.693,3.084a.788.788,0,0,1-.549.928,1.5,1.5,0,0,0-1.235,1.764c.137.6.732,1.235,1.98,1.032a.785.785,0,1,1,.255,1.549,4.551,4.551,0,0,1-.712.059Z",
    transform: "translate(-69.507 -40.399)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M202.515,133.312a.783.783,0,0,1-.47-.157l-1.261-.954a.784.784,0,1,1,.941-1.255l1.261.954a.783.783,0,0,1,.157,1.1.8.8,0,0,1-.627.314Z",
    transform: "translate(-69.471 -45.324)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M232.351,171.794c-1.9-10.05-12.573-23.2-12.573-23.2-.065-13.978-1.751-16.657-4.79-17.467-4.535-1.209-7.691,2.529-9.05,10.86a39.678,39.678,0,0,0-3.4-2.673c-2.653-1.647-7.155-2.209-9.351,1.17-2.79,4.287-.549,8.345,3.836,12.357a6.1,6.1,0,0,0-3.967,7.567s-6.554,2.627-4.091,8.763c0,0-6.646,4.5-1.013,10.351a102.356,102.356,0,0,0,16.964,13.736l24.145,30.915,26.537-27.04L232.345,171.8Z",
    transform: "translate(-64.347 -45.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M228.651,224.54a.825.825,0,0,1-.621-.3l-24.06-30.811a103.457,103.457,0,0,1-16.99-13.781c-1.843-1.908-2.666-3.908-2.457-5.94a8.293,8.293,0,0,1,3.091-5.221,6.61,6.61,0,0,1,1.483-6.946,9.9,9.9,0,0,1,2.653-1.986,6.669,6.669,0,0,1,3.476-7.351c-3.182-3.1-6.378-7.541-3.11-12.56,2.522-3.868,7.613-3.15,10.423-1.4A27.435,27.435,0,0,1,205,140.1c.954-4.816,2.588-8,4.855-9.469a5.922,5.922,0,0,1,4.927-.673c3.568.948,5.286,3.888,5.371,17.944,1.431,1.8,10.612,13.612,12.514,23.113l23.1,25.165a.782.782,0,0,1-.02,1.078L229.207,224.3a.8.8,0,0,1-.562.235Zm-31.046-86.152a4.747,4.747,0,0,0-4.169,2.111c-2.248,3.45-1.1,6.946,3.705,11.351a.773.773,0,0,1,.235.751.783.783,0,0,1-.536.575,5.307,5.307,0,0,0-3.431,6.639.788.788,0,0,1-.47.908c-.235.1-5.79,2.418-3.653,7.737a.784.784,0,0,1-.288.941c-.026.02-2.64,1.836-2.908,4.476a5.934,5.934,0,0,0,2.026,4.679,102.018,102.018,0,0,0,16.813,13.612.769.769,0,0,1,.2.183l23.59,30.209,25.387-25.87L231.363,171.91a.835.835,0,0,1-.2-.386c-1.843-9.743-12.3-22.727-12.409-22.858a.79.79,0,0,1-.176-.49c-.065-14.435-1.941-16.108-4.208-16.709a4.367,4.367,0,0,0-3.666.47c-2.058,1.333-3.581,4.7-4.4,9.756a.789.789,0,0,1-1.294.471,39.718,39.718,0,0,0-3.3-2.6,8.123,8.123,0,0,0-4.11-1.183Z",
    transform: "translate(-63.934 -44.95)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M225.443,156.11a.782.782,0,0,1-.51-.19l-9.168-7.881a.783.783,0,1,1,1.019-1.189l9.168,7.881a.785.785,0,0,1,.085,1.1A.775.775,0,0,1,225.443,156.11Z",
    transform: "translate(-74.677 -50.825)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M205.911,167.527a.783.783,0,0,1-.5-.176l-3.287-2.679a.785.785,0,0,1,.993-1.215l3.287,2.679a.784.784,0,0,1-.5,1.392Z",
    transform: "translate(-69.946 -56.583)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M200.081,179.1a.781.781,0,0,1-.477-.163l-3.529-2.686a.783.783,0,1,1,.947-1.248l3.529,2.686a.781.781,0,0,1-.477,1.4Z",
    transform: "translate(-67.841 -60.591)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M193.966,192.644a.781.781,0,0,1-.477-.163l-3.672-2.816a.783.783,0,0,1,.954-1.242l3.672,2.816a.784.784,0,0,1-.477,1.4Z",
    transform: "translate(-65.672 -65.239)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M92.8,161.245a6.626,6.626,0,0,0,6.646,8.684,6.878,6.878,0,0,1,5.4,1.862c1.1,1.15,3.176,4.346,4.3,5.862,0,0-9.717-1.993-10.553,6.123-6.332-9.475-12.932-13.664-18.179-7.92-4.5,4.914,3.28,13.01,6.5,19.048,3.666,6.861,7.534,14.3,14.363,16.454L111.762,239.6h43.109l-19.159-34.914s.595-17.493-1.072-24.452c-1.039-4.326-9.488-9.22-9.488-9.22-6.4-10.018-10.455-18.6-24.714-15.33-4.653,1.065-6.809,3.215-7.639,5.567Z",
    transform: "translate(-27.394 -53.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M154.46,239.975H111.351a.792.792,0,0,1-.738-.51l-10.351-27.883c-6.783-2.346-10.586-9.469-14.258-16.356l-.19-.353c-.751-1.411-1.758-2.934-2.823-4.542-3.47-5.254-7.4-11.213-3.568-15.409a7.687,7.687,0,0,1,6.371-2.849c3.725.281,7.757,3.424,11.984,9.344a6.723,6.723,0,0,1,2.47-3.489,10.8,10.8,0,0,1,6.822-1.653c-.1-.15-.216-.307-.32-.464a43.253,43.253,0,0,0-2.882-3.875,6.02,6.02,0,0,0-4.809-1.614,7.6,7.6,0,0,1-6.41-3.091,7.072,7.072,0,0,1-1-6.633c1.065-3.026,3.829-5.064,8.2-6.071,13.729-3.15,18.565,4.542,24.152,13.455.425.68.856,1.366,1.3,2.065,1.248.745,8.658,5.313,9.691,9.619,1.594,6.646,1.17,22.322,1.1,24.446l19.055,34.725a.786.786,0,0,1-.686,1.163Zm-42.56-1.568h41.233l-18.519-33.751a.863.863,0,0,1-.1-.405c0-.176.568-17.467-1.052-24.243-.784-3.28-6.848-7.41-9.116-8.724a.772.772,0,0,1-.268-.255c-.484-.751-.948-1.5-1.411-2.235-5.7-9.09-9.828-15.657-22.472-12.756-3.816.876-6.2,2.581-7.077,5.064a5.549,5.549,0,0,0,.784,5.182,6.047,6.047,0,0,0,5.09,2.45,7.515,7.515,0,0,1,6,2.1,42.987,42.987,0,0,1,3.039,4.065c.5.712.967,1.385,1.327,1.869a.783.783,0,0,1-.784,1.235c-.046-.007-4.587-.9-7.4,1.17a5.723,5.723,0,0,0-2.209,4.261.779.779,0,0,1-.595.68.791.791,0,0,1-.843-.327c-4.274-6.391-8.371-9.906-11.854-10.174a6.106,6.106,0,0,0-5.09,2.339c-3.006,3.293.412,8.475,3.718,13.481,1.085,1.64,2.111,3.2,2.895,4.666l.19.353c3.594,6.737,7.312,13.7,13.716,15.722a.768.768,0,0,1,.5.477l10.292,27.726Z",
    transform: "translate(-26.977 -53.301)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M115.552,201.307c-4.228,0-7.757-5.489-7.926-5.764a.786.786,0,0,1,1.327-.843c.046.065,4.378,6.809,8.332,4.548a5.648,5.648,0,0,0,3.11-3.829c.471-2.843-1.947-5.626-1.967-5.652a.787.787,0,0,1,1.183-1.039c.118.137,2.934,3.378,2.339,6.946a7.091,7.091,0,0,1-3.875,4.934,5.013,5.013,0,0,1-2.509.693Z",
    transform: "translate(-37.255 -65.309)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M120.962,204.112a.788.788,0,0,1-.751-.555l-1.549-5.084a.786.786,0,0,1,1.5-.457l1.549,5.084a.785.785,0,0,1-.523.98A.693.693,0,0,1,120.962,204.112Z",
    transform: "translate(-41.11 -68.427)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M153.838,188.4a.789.789,0,0,1-.693-.412l-4.646-8.528a.785.785,0,0,1,1.379-.751l4.646,8.528a.786.786,0,0,1-.314,1.065.774.774,0,0,1-.373.1Z",
    transform: "translate(-51.428 -61.789)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_996",
    "data-name": "Rectangle 996",
    width: 90.824,
    height: 72.207,
    rx: 12.54,
    transform: "translate(161.097 114.617)",
    fill: "#66a2e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M280.859,247.357a4.372,4.372,0,0,1-3.784-6.561l21.466-37.175a4.373,4.373,0,0,1,7.574,0L327.581,240.8a4.372,4.372,0,0,1-3.784,6.561H280.872Z",
    transform: "translate(-95.812 -69.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M313.328,239.035A4.329,4.329,0,0,1,309,234.9l-.745-16.533a5.076,5.076,0,1,1,10.142,0l-.745,16.533A4.333,4.333,0,0,1,313.328,239.035Z",
    transform: "translate(-106.822 -73.834)",
    fill: "#f39797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M317.933,258.911a4.051,4.051,0,1,1-4.051-4.051A4.051,4.051,0,0,1,317.933,258.911Z",
    transform: "translate(-107.369 -88.319)",
    fill: "#f39797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M329.33,175.4H254.548a8.2,8.2,0,0,0-8.018,8.371v3.784h90.824v-3.784a8.2,8.2,0,0,0-8.018-8.371Z",
    transform: "translate(-85.433 -60.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M336.945,187.917H246.121a.773.773,0,0,1-.771-.771v-3.784a8.981,8.981,0,0,1,8.789-9.142h74.782a8.981,8.981,0,0,1,8.789,9.142v3.784a.773.773,0,0,1-.771.771Zm-90.053-1.536h89.289v-3.012a7.444,7.444,0,0,0-7.253-7.606H254.146a7.444,7.444,0,0,0-7.253,7.606Z",
    transform: "translate(-85.024 -60.374)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 2.568,
    cy: 2.568,
    r: 2.568,
    transform: "translate(242.865 117.773)",
    fill: "#febc75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M364.3,182.8a2.568,2.568,0,1,1-2.568-2.568A2.568,2.568,0,0,1,364.3,182.8Z",
    transform: "translate(-124.464 -62.457)",
    fill: "#f39797"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 7.469,
    cy: 7.469,
    r: 7.469,
    transform: "translate(56.263 109.494)",
    fill: "#f39797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M284.477,60.741l7.175-13.677a1.325,1.325,0,0,1,2.124-.307l9.416,9.665a1.326,1.326,0,0,1-.64,2.215l-16.591,4.012a1.323,1.323,0,0,1-1.483-1.9Z",
    transform: "translate(-98.529 -16.064)",
    fill: "#d9dfed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M267.162,55.438l-3.888-7.528a1.616,1.616,0,0,1,1.032-2.307l5.293-1.372a1.614,1.614,0,0,1,2,1.817l-1.4,8.894a1.616,1.616,0,0,1-3.032.49Z",
    transform: "translate(-91.172 -15.309)",
    fill: "#d9dfed"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 3.045,
    cy: 3.045,
    r: 3.045,
    transform: "translate(32.817 6.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 3.045,
    cy: 3.045,
    r: 3.045,
    transform: "translate(42.514 6.789)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLoginIcon);
export default __webpack_public_path__ + "static/media/error-login-icon.bdfea5a41aa85f2bd4942a991593bd2b.svg";
export { ForwardRef as ReactComponent };